import type { FC } from "react";

import type { MomentAnalyticsCellDataDisplay } from "../hooks/utils";

export const ValueCellDisplay: FC<{
  cellData?: MomentAnalyticsCellDataDisplay;
}> = ({ cellData }) => (
  <>
    {cellData?.type === "number" && <>{cellData.value}</>}
    {cellData?.type === "percentage" && <>{`${cellData.value}%`}</>}
    {cellData?.type === null && <>-</>}
  </>
);
